// Şube yöneticisinin kurye yetkileri: managerPanel ayarlarındaki "courier" ve "courier_subPermissions".
// Kural backend'deki ManagerPanelPermissions.IsGranted(courier_*) ile aynıdır: alt yetki yalnız
// üst modül (courier) açıkken geçerlidir.

export interface CourierUiPermissions {
  canView: boolean;
  canManage: boolean;
  canSettle: boolean;
  canPayout: boolean;
  canReport: boolean;
}

export const COURIER_NONE: CourierUiPermissions = {
  canView: false, canManage: false, canSettle: false, canPayout: false, canReport: false,
};

export const resolveCourierPermissions = (settings: any): CourierUiPermissions => {
  const s = settings || {};
  const open = s.courier === true;
  const subs = s.courier_subPermissions || {};
  return {
    canView: open,
    canManage: open && subs.courier_manage === true,
    canSettle: open && subs.courier_settlement === true,
    canPayout: open && subs.courier_payout === true,
    canReport: open && subs.courier_report === true,
  };
};
